import React from "react";
import {useTranslation} from "react-i18next";
//local
import {VideoInstruction} from "components/VideoInstruction";
import {IconCalendar} from "components/icons";

import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {SubscriptionUpgradeCustomLocalModal} from "components/modals/SubscriptionUpgradeCustomLocalModal";
import {openNewTab, hasPermission} from "helpers/helper";
import Star from "assets/images/svg/star.svg";
import {color} from "constants/color.consts";
import cn from "classnames";

const baseKey = "UPSALE_BOX_LOCAL_MODAL_";

// priceBlobAlign = "right" | "left"

export const UpsaleBoxLocalModal = ({
  permissions,
  additionalShowCondition = true,
  position,
  priceBlobAlign = "right",
  data,
  extraData,
  addClass,
}) => {
  const {t} = useTranslation();

  const wrapperStyle = {...position};
  const SubscriptionUpgradeCustomLocalModalSuffixContent = () => (
    <div className="local-upsale-box_extras">
      {t(extraData?.title ?? `${baseKey}EXTRA_TITLE`)}
      <div
        className="df-row-center pb-4 mb-1"
        style={{borderBottom: `1px solid ${color.formBorder}`}}
      >
        <ButtonTransparent
          name={t(extraData?.bookButtonName ?? `${baseKey}BUTTON_BOOK_NAME`)}
          icon={<IconCalendar color={color.white} />}
          small
          nonTransparent
          onClick={
            extraData?.bookButtonUrl
              ? () => openNewTab(t(extraData?.bookButtonUrl))
              : undefined
          }
          addClass="mr-2"
        />
        <ButtonTransparent
          name={t(extraData?.infoButtonName ?? `${baseKey}BUTTON_INFO_NAME`)}
          small
          onClick={
            extraData?.bookButtonUrl
              ? () => openNewTab(t(extraData?.infoButtonUrl))
              : undefined
          }
        />
      </div>
      <VideoInstruction
        url={t(extraData?.videoUrl)}
        title={t(extraData?.videoTitle)}
        containerSize={extraData?.videoSize ?? {width: "233", height: "142"}}
        fitContainerSize
      />
    </div>
  );

  if (hasPermission(permissions) || !additionalShowCondition) return null;

  return (
    <SubscriptionUpgradeCustomLocalModal
      canPermissions={permissions}
      needDirectPurchase={!data?.directSubscriptionLink}
      directSubscriptionLink={data?.directSubscriptionLink}
      addClass={cn("local-upsale-box", {[addClass]: !!addClass})}
      addStyle={wrapperStyle}
      suffixLinkCustomContent={
        // Note to future Johan: this is the custom upgrade box unclickable suffix content
        <SubscriptionUpgradeCustomLocalModalSuffixContent />
      }
    >
      {/* Note to future Johan: this is the custom upgrade box clickable content */}
      <div className="local-upsale-box_data">
        <div className="offer df-column-center">
          <p className="mb-4">{t(data?.title)}</p>
          <div className="cta">
            <span className="action">
              {!!data?.buttonIcon && <span className="pulser">&nbsp;</span>}
              {data?.buttonIcon}
              <span className="text">
                {data.buttonServiceExtraName ? (
                  t(data.buttonServiceExtraName)
                ) : (
                  <React.Fragment>
                    <span>{t("GET_THE_SERVICE")}</span>
                    <span className="name">{t(data?.buttonServiceName)}</span>
                  </React.Fragment>
                )}
              </span>
            </span>
          </div>
        </div>
        {!!data?.priceValue && (
          <div
            className={cn("price-blob", {
              __left: priceBlobAlign === "left",
              __right: priceBlobAlign === "right",
            })}
          >
            <img className="star" src={Star} alt="" width="100%" height="100%" />
            <div className="star-content">
              <span className="price-type">{t(data?.priceLabel)}</span>
              <span className="price">{t(data?.priceValue)}</span>
              <span className="price-type">{t(data?.priceType)}</span>
            </div>
          </div>
        )}
      </div>
    </SubscriptionUpgradeCustomLocalModal>
  );
};
